// Generated by project-unified; do not edit.
export const expectedUnifiedSnapshotIdentity = "sha256:bc222c95b47d260a7b1b2788431ff667958ac65f2a4c0a652d35da2a21bb8288";
export const expectedUnifiedSnapshotURL = "/lab-data/unified-campaign-bc222c95b47d260a7b1b2788431ff667958ac65f2a4c0a652d35da2a21bb8288.json";
